import React from 'react';
import { connect } from 'react-redux';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Topbar from '../topbar/Topbar';
import Footer from '../footer/Footer';

class Layout extends React.Component {
  renderBreadcrumb(history) {
    const breadcrumbItems = this.props.breadcrumbItems || [];
    const { key } = history.location;
    return (
      <div >
        <Breadcrumb className="navbar-left">
          <Breadcrumb.Item active>
            <i className="fas fa-home" />
          </Breadcrumb.Item>
          {breadcrumbItems.map(({ name, path }, index, array) => (
            <Breadcrumb.Item key={`bcit-${index}`} active>
              {array.length === index + 1 ? name : <Link to={path}>{name}</Link>}
            </Breadcrumb.Item>
          ))}
          </Breadcrumb>
          <a onClick={ ()=> key && history.goBack() } className="navbar-right" style={btnPosition} >
            <i class="fas fa-arrow-circle-left fa-2x" style={ key ? backBtnSyle : disabledStyle } />
          </a>
      </div>
    );
  }

  render() {
    const { isShowSideMenu, history } = this.props;
    const renderActionMenu = this.props.renderActionMenu || (() => {});

    return (
      <div
        className={
          'application-content off-canvas col-sm-9 col-md-10 col-sm-offset-3 col-md-offset-2' +
          (isShowSideMenu ? '' : ' menu-hide')
        }
      >
        <Topbar
          renderActionMenu={renderActionMenu}
          history={history}
          help={this.props.help}
        />
        {this.renderBreadcrumb(history)}
        <div className="main-content">{this.props.children}</div>
        <Footer />
      </div>
    );
  }
}

const btnPosition = {
  paddingRight: 35,
  paddingTop:5,
  paddingBottom:5,
}
const backBtnSyle = {
  fontSize:"1.6em",
  cursor: 'pointer',
};
const disabledStyle = {
  fontSize:"1.6em",
  color: "grey",
}

const mapStateToProps = state => ({
  isShowSideMenu: state.app.isShowSideMenu,
});

export default connect(
  mapStateToProps,
  null,
)(Layout);

// Example
// const breadcrumbItems = [{ name: t('dashboard'), path: '/dashboard' }];
// const helpConfig = {
//   title: 'Dashboard help',
//   contentUrl: 'https://bec-uat.everyresearch.com/help/dashboard.html/',
// };
//
// <Layout
//   history={this.props.history}
//   breadcrumbItems={breadcrumbItems}
//   help={helpConfig}
// >



// WEBPACK FOOTER //
// ./src/components/layout/Layout.js